export type FontSizeClass = 'text-2xl' | 'text-xl' | 'text-lg' | 'text-sm';

const FONT_SIZES_BY_VALUE: FontSizeClass[] = ['text-sm', 'text-lg', 'text-xl', 'text-2xl'];

export const MAX_FONT_SIZE_VALUE = FONT_SIZES_BY_VALUE.length - 1;
export const MIN_FONT_SIZE_VALUE = 0;

export const getFontSizeClass = (value: number): FontSizeClass => {
  return FONT_SIZES_BY_VALUE[value];
};
